"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTabsStyles = exports.tabsVars = exports.tabsCommon = void 0;
var _createUseStyles = _interopRequireDefault(require("../../themes/createUseStyles"));
var _commonProps = require("../../utils/vars/commonProps");
var _initVars = _interopRequireDefault(require("../../utils/vars/initVars"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } /**
 * @copyright
 * Copyright (c) 2025 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var tabsCommon = exports.tabsCommon = ["width"].concat(_toConsumableArray(_commonProps.defaultCommonProps));
var tabsVars = exports.tabsVars = (0, _initVars.default)({
  applied: tabsCommon,
  variables: [{
    key: "tabsExpandTransform"
  }, {
    key: "tabsExpandWidth"
  }]
});
var styles = function styles(theme) {
  return {
    variables: tabsVars.styles,
    root: {
      display: "flex",
      minHeight: theme.spacing.base * 6,
      height: "auto",
      position: "relative",
      background: "none",
      fontFamily: theme.typography.fontFamily,
      borderBottom: [1, "solid", theme.colors.baseContrast020]
    },
    indicator: {
      position: "absolute",
      bottom: 0,
      marginInlineStart: 0,
      zIndex: 1,
      height: 2,
      background: theme.colors.primary,
      transition: "350ms all",
      width: tabsVars.get("tabsExpandWidth"),
      transform: tabsVars.get("tabsExpandTransform")
    }
  };
};
var useTabsStyles = exports.useTabsStyles = (0, _createUseStyles.default)(styles, {
  name: "Tabs"
});